export default "__VITE_ASSET___kKyg6Ei__"